module.exports = __webpack_public_path__ + "placentsn-f4c5fe76.webp";